import { render, staticRenderFns } from "./PackMarkDetailRecord.vue?vue&type=template&id=48a278ce&scoped=true&"
import script from "./PackMarkDetailRecord.vue?vue&type=script&lang=js&"
export * from "./PackMarkDetailRecord.vue?vue&type=script&lang=js&"
import style0 from "./PackMarkDetailRecord.vue?vue&type=style&index=0&id=48a278ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a278ce",
  null
  
)

export default component.exports